module.exports = __webpack_public_path__ + "img/NFC_scan_error.eb95a565.png";